exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tblClass[data-v-775c4f26]{border-collapse:collapse}.tblClass tr td[data-v-775c4f26],.tblClass tr th[data-v-775c4f26]{border:1px solid #ccc;padding:8px 0}.textCenter[data-v-775c4f26],.textCenter tr td[data-v-775c4f26],.textCenter tr th[data-v-775c4f26]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-775c4f26","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procurement/package/detailsView.vue
// module id = 1448
// module chunks = 3